<template>
  <div style="padding: 15px; background-color: #fefefe">
    <el-page-header
      @back="back"
      title
      content="Histórico da Coleta"
      style="margin-bottom: 2.5rem"
    ></el-page-header>
    <h6 style="margin-bottom: 1rem">Total por serviço:</h6>
    <div style="display: flex; margin-bottom: 15px">
      <el-card
        style="margin-left: 5px"
        v-for="item in countByServices"
        :key="item.name"
      >
        <span>
          <strong style="color: rgb(50, 50, 49)">
            {{ item.service }}
          </strong>
          : {{ item.total }}
        </span>
      </el-card>
    </div>
    <el-collapse>
      <el-collapse-item
        :title="'OBJETOS Coletados: (' + historyData.length + ')'"
      >
        <el-table :data="historyData">
          <el-table-column align="center" prop="tag" label="Objeto">
            <template slot-scope="scope">
              {{ scope.row.tag}} <i class="el-icon-check" title="Objeto aferido na unidade" v-if="scope.row.malha"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="service" label="Serviço" />
          <el-table-column align="center" prop="plp" label="PLP" />
          <el-table-column align="center" prop="order_id" label="O.S" />
          <el-table-column
            align="center"
            prop="destinyZipcode"
            label="CEP Destino" />
          <el-table-column
            align="center"
            prop="destinyName"
            label="Cliente"
        /></el-table>
      </el-collapse-item>

      <el-collapse-item :title="'Dados O.Ss'">
        <el-table :data="ordersData">
          <el-table-column align="center" prop="id" label="OS" width="80" />
          <el-table-column
            align="center"
            prop="driver"
            label="Motorista"
            width="250"
          />
          <el-table-column
            align="center"
            prop="receiverName"
            label="Nome Recebedor"
            width="250"
          />
          <el-table-column
            align="center"
            prop="orderType"
            label="Tipo de O.S"
          />
          <el-table-column
            align="center"
            prop="totalObjects"
            label="Total De Objetos"
          />
          <el-table-column
            align="center"
            prop="totalObjectsMaisEnvios"
            label="Objetos Mais Envios"
          />
          <el-table-column
            align="center"
            prop="totalObjectsExternal"
            label="Objetos PLP Terceiros"
          />
          <el-table-column prop="" label="#" align="center">
            <template slot-scope="scope">
              <el-tooltip content="Download">
                <el-button
                  @click="print(scope.row.id)"
                  type="primary"
                  icon="el-icon-download"
                  circle
                  style="font-size: 18px; font-weight: bold"
                />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { OrderServicesService } from "@/services/customers/order.services.services";

export default {
  name: "CollectHistory",

  data() {
    return {
      pendency_id: "",
      historyData: [],
      externalHistoryData: [],
      countByServices: [],
      ordersData: [],
      src_image: "",
    };
  },

  methods: {
    findHistory() {
      const loading = this.$loading(this.$options.loading);
      console.log('this.pendency_id', this.pendency_id)
      OrderServicesService.findByPendencyId(this.pendency_id)
        .then((response) => {
          this.historyData = response.historyData.filter(
            (item) => !item.service.includes("PLP Terceiros")
          );
          this.externalHistoryData = response.historyData.filter((item) =>
            item.service.includes("PLP Terceiros")
          );
          this.countByServices = response.totalByService;
          this.ordersData = response.ordersData;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    print(id) {
      const loading = this.$loading(this.$options.loading);
      OrderServicesService.print(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response.data;
          downloadLink.download = `${id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    back() {
      this.$router.push(`/rota/realtime`);
    },
  },

  mounted() {
    this.pendency_id = this.$route.params.pendency_id;
    this.findHistory();
  },
};
</script>
